import { useContext } from "react";
import AuthContext from "../context/AuthContext";

export function usePermission(permission) {
  const { user } = useContext(AuthContext);

  if (!user) return false;

  if (user.isAdmin) return true;

  if (!user.permissions || !Array.isArray(user.permissions)) {
    return false;
  }

  const required = Array.isArray(permission) ? permission : [permission];

  return required.some((item) => user.permissions.includes(item));
}
